import { mapGetters } from 'vuex'
import dayjs from '@services/date/index'

export default {
  computed: {
    ...mapGetters({
      currentUser: 'auth/currentUser',
      invoiceData: 'singleInvoice/invoiceData',
    }),
  },
  methods: {
    displayInvoiceDate(invoiceData) {
      if (invoiceData.datePaid !== null && invoiceData.datePaid !== '') {
        return dayjs(invoiceData.datePaid).format('DD/MM/YYYY') // the data displayed is melb date when the invoice is created
      }
      return ''
    },
    isInvoicePaid(invoiceData) {
      if (!invoiceData.datePaid) {
        return 'red'
      }
      // no color
      return ''
    },
    isInvoiceLabel(invoiceData) {
      if (!invoiceData.datePaid) {
        return this.$t('finance.invoiceViewSummaryNotPaidLabel')
      }
      // no color
      return this.$t('finance.invoiceViewSummaryPaidLabel')
    },
    displayCurrency(input) {
      return new Intl.NumberFormat(this.currentUser.language, {
        style: 'currency',
        currency: this.currentUser.currencyCode,
      }).format(input)
    },
    countDisplayTotal(invoicedata) {
      const invoiceTotal = invoicedata.exGSTAmount + invoicedata.taxAmount
      return this.displayCurrency(invoiceTotal)
    },
    displayGSTtext() {
      if (
        this.currentUser.currencyCode !== null &&
        this.currentUser.currencyCode !== ''
      ) {
        return this.$t('finance.invoiceViewRegionTaxLabel')
      }
    },
    displayDate(dateData) {
      const convertDate = dayjs(dateData.date)
        .tz(dateData.countryTimezone, false)
        .format('DD/MM/YYYY')
      return convertDate
    },
    displayHour(dateData) {
      const convertTime = dayjs(dateData.date)
        .tz(dateData.countryTimezone, false)
        .format('HH:mm')
      return convertTime
    },
    countdisplayPlacementRate(item) {
      const exTaxAmount = item.clientRate * item.clientHours
      return this.displayCurrency(exTaxAmount)
    },
  },
}
